
import { Component, Prop, Vue } from 'vue-property-decorator';

import FileSaver from 'file-saver';
import Swal from 'sweetalert2';

import { eventBus, EventType } from '../eventBus';
import { AssessmentInstance, ProgressStatus, Section } from '../models';
import { httpPost } from '../utils';

@Component
export default class Sidebar extends Vue {
  @Prop(Object) private readonly assessment!: AssessmentInstance;

  private isLoading: boolean = false;

  get sortedSections(): Section[] {
    return this.assessment.sections.sort((s1, s2) => s1.sortOrder - s2.sortOrder);
  }

  get allSectionsCompleted(): boolean {
    return this.assessment.sections.every((s) => s.progress === ProgressStatus.Completed);
  }

  private created() {
    eventBus.$on(EventType.SECTION_MADE_PROGRESS, (sectionId: number) => {
      const section = this.assessment.sections.find((s) => s.id === sectionId);
      if (section !== undefined) {
        section.progress = ProgressStatus.InProgress;
      }
    });
    eventBus.$on(EventType.SECTION_COMPLETED, (sectionId: number) => {
      const section = this.assessment.sections.find((s) => s.id === sectionId);
      if (section !== undefined) {
        section.progress = ProgressStatus.Completed;
      }
    });
  }

  private getProgressStatus(section: Section): string {
    if (section.progress === ProgressStatus.Completed) {
      return 'Completed';
    } else if (section.progress === ProgressStatus.InProgress) {
      return 'In Progress';
    } else {
      return 'Not Started';
    }
  }

  private async generateReport() {
    const url = `${process.env.VUE_APP_API_HOST}/assessments/${this.assessment.id}/generate-report`;
    const accessToken: string = await (this as any).$auth0.getAccessTokenSilently();
    this.isLoading = true;
    fetch(url, {
      method: 'POST',
      body: JSON.stringify(accessToken),
      headers: {
        'Authorization': `Bearer ${accessToken}`,
        'Content-Type': 'application/json',
      },
    }).then((response) => {
      if (response.ok) {
        return response.blob();
      }
      throw new Error('Bad response');
    }).then((blob) => {
      const objectUrl = URL.createObjectURL(blob);
      FileSaver.saveAs(objectUrl, 'report.pdf');
    }).catch((error) => {
      Swal.fire({
        title: 'Report Generation Failed',
        text: `Error: ${error.message}`,
        type: 'error',
      });
    }).then(() => {
      this.isLoading = false;
    });
  }
}
